// extracted by mini-css-extract-plugin
export var container = "_s3-0";
export var inputWidth = "_s3-1";